import { Injectable } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { UI_REDUCER } from '@safarilaw-webapp/shared/redux';

import {
  SafariUiAccordionGroupReduxObject,
  SafariUiAccordionReduxObject,
  SafariUiComponentReduxObject,
  SafariUiDataTableReduxObject,
  SafariUiFilePreviewReduxObject,
  SafariUiFlyoutButtonReduxObject,
  SafariUiFormReduxObject,
  SafariUiPageSidebarReduxObject,
  SafariUiTabReduxObject
} from './actions/layout-actions';
import { IAppControlState } from './interfaces/layout-interface';
import { SafariInjector } from '@safarilaw-webapp/shared/common-objects-models';

@Injectable({
  providedIn: 'root'
})
export class UiReducerService extends SafariInjector {
  private _accordionReduxObject: SafariUiAccordionReduxObject;
  private _accordionControllerReduxObject: SafariUiAccordionGroupReduxObject;
  private _formReduxObject: SafariUiFormReduxObject;
  private _tableReduxObject: SafariUiDataTableReduxObject;
  private _tabReduxObject: SafariUiTabReduxObject;
  private _flyoutButtonReduxObject: SafariUiFlyoutButtonReduxObject;
  private _uiComponentReduxObject: SafariUiComponentReduxObject;
  private _filePreviewObject: SafariUiFilePreviewReduxObject;
  private _pageSidebarReduxObject: SafariUiPageSidebarReduxObject;
  constructor() {
    super();
    this._accordionReduxObject = this.inject(SafariUiAccordionReduxObject);
    this._accordionControllerReduxObject = this.inject(SafariUiAccordionGroupReduxObject);
    this._formReduxObject = this.inject(SafariUiFormReduxObject);
    this._tableReduxObject = this.inject(SafariUiDataTableReduxObject);
    this._tabReduxObject = this.inject(SafariUiTabReduxObject);
    this._flyoutButtonReduxObject = this.inject(SafariUiFlyoutButtonReduxObject);
    this._uiComponentReduxObject = this.inject(SafariUiComponentReduxObject);
    this._filePreviewObject = this.inject(SafariUiFilePreviewReduxObject);
    this._pageSidebarReduxObject = this.inject(SafariUiPageSidebarReduxObject);
  }
  get reducers() {
    const reducers: ActionReducerMap<IAppControlState> = {
      componentState: UI_REDUCER(this._uiComponentReduxObject),
      formState: UI_REDUCER(this._formReduxObject),
      listState: UI_REDUCER(this._tableReduxObject),
      filePreviewState: UI_REDUCER(this._filePreviewObject),
      tabState: UI_REDUCER(this._tabReduxObject),
      flyoutButtonState: UI_REDUCER(this._flyoutButtonReduxObject),
      pageSidebarState: UI_REDUCER(this._pageSidebarReduxObject),
      accordionState: UI_REDUCER(this._accordionReduxObject),
      accordionControllerState: UI_REDUCER(this._accordionControllerReduxObject)
    };
    return reducers;
  }
}
